import React, {createContext, useReducer} from 'react';
import FormReducer from "./reducers/FormReducer";
import formInitialState from "./initialStates/formInitialState";

export const GlobalContext = createContext(null);

export const GlobalProvider = ({children, careerId}) => {
    const [state, dispatch] = useReducer(FormReducer, {
        ...formInitialState,
        careerId: careerId
    });
    return (
        <GlobalContext.Provider value={{
            state,
            dispatch,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};
